import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Card } from 'semantic-ui-react';
import { fieldTypeName, fieldTypeNameWithConstraint } from '@/constants/fields';

const DictionaryFieldCardItemExtra = ({ type, lookups, constraint }) => {
  const hasLookup = !!lookups[constraint];

  return (
    <Card.Content extra>
      {hasLookup && (<FormattedMessage id={fieldTypeNameWithConstraint(type)} values={{ constraint }} />)}
      {!hasLookup && (<FormattedMessage id={fieldTypeName(type)} />)}
    </Card.Content>
  );
};

export default DictionaryFieldCardItemExtra;
